import { Edit } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const EditEmployees = () => {
  return (
    <Edit
      mutationMode="pessimistic"
      title="Редакция на служител в структурата"
      actions={<BackButtonToolbar />}
    >
      <SaveForm isEdit />
    </Edit>
  );
};
export default EditEmployees;
